<label
  class="relative w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden border-2 border-dashed border-blue-300 bg-blue-50 hover:border-blue-500 hover:bg-blue-100 transition cursor-pointer flex items-center justify-center"
  [class.cursor-not-allowed]="!editable()"
>
  @if (imagenPreviewUrl() || initialUrl()) {
    <img
      [src]="imagenPreviewUrl() || initialUrl()!"
      alt="Preview de imagen del producto"
      class="w-full h-full object-cover"
    />
  } @else if (editable() == true) {
    <div class="text-center px-2">
      <i class="bi bi-camera text-blue-600 text-lg"></i>
      <p class="text-[10px] text-blue-700 font-semibold leading-tight mt-1">Subir foto</p>
    </div>
  }
  @if (editable() == true) {
    <input
      type="file"
      accept="image/png,image/jpeg,image/webp"
      class="hidden"
      (change)="onFileChange($event)"
    />
  }
</label>
